import { render, staticRenderFns } from "./AiWidgetView.vue?vue&type=template&id=a81aeb96&scoped=true&"
import script from "./AiWidgetView.vue?vue&type=script&lang=js&"
export * from "./AiWidgetView.vue?vue&type=script&lang=js&"
import style0 from "./AiWidgetView.vue?vue&type=style&index=0&id=a81aeb96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81aeb96",
  null
  
)

export default component.exports